import React from 'react';
import { Text } from './Text';
import { Button } from './Text';
import Card from './Card';
import buyMilesIcon from '../assets/thumbnail/buy-thumbnail.png';
import giftMilesIcon from '../assets/thumbnail/gift-thumbnail.png';
import multiplyIcon from '../assets/thumbnail/miles-by-the-month-thumbnail.png';
import subscribeIcon from '../assets/thumbnail/subscribe-thumnail.png';
import buyMiles2BlueIcon from '../assets/icons/buy_miles_2_teal.svg';
import subscriptionIcon from '../assets/icons/new.png';
import subscriptionIconES from '../assets/icons/new_es.png';
import subscriptionIconPT from '../assets/icons/new_pt.png';
import subscriptionIconJA from '../assets/icons/new.png';

export const Buy = ({ languageCode, toggleHiddenBuy, toggleHiddenGift }) => {
  const icons = {
    "en-US": "New!",
    "es-ES": "¡Nuevo!",
    "pt-BR": "Novo!",
    "jp-JP": "New!"
  };

  return (
    
    <div className="main-item buy clearfix" id="buy">
      <div className="main-item_content">
        <h3><Text languageCode={languageCode} token="buy.subheader" /></h3>
        <h2 className="buy-header"><Text languageCode={languageCode} token="buy.header" /></h2>
        <h4><Text languageCode={languageCode} token="buy.text" /></h4>

        <div className="main-item_cards">
        {/* Card 1 - Buy Yourself */}
        <Card
            buyMilesIcon={buyMilesIcon} // Corrected: Added buyMilesIcon
            title="buy.button.yourself"
            description="buy.tooltip.yourself"
            buttonText="buy.button.yourself"
            url="buy.yourself.link.url"
            languageCode={languageCode}
            buttonClassName="buy-link-pcta-copy"
            buttonId="buy-cta-button"
            promoToken="buy.onsale.token"
          />

          {/* Card 2 - Gift to Another */}
          <Card
            buyMilesIcon={giftMilesIcon} // Corrected: Added buyMilesIcon
            title="buy.button.another"
            description="buy.tooltip.another"
            buttonText="buy.button.another"
            url="buy.another.link.url"
            languageCode={languageCode}
            buttonClassName="gift-link-pcta-copy"
            buttonId="gift-cta-button"
            promoToken="gift.onsale.token"
          />


          {/* Card 3 - Multiply */}

          <Card
            buyMilesIcon={multiplyIcon} // Corrected: Added buyMilesIcon
            title="buy.button.multiply"
            description="buy.tooltip.multiply"
            buttonText="buy.button.multiply"
            url="buy.multiply.link.url"
            languageCode={languageCode}
            buttonClassName="gift-link-pcta-copy"
            buttonId="multiply-cta-button"
            promoToken="multiply.onsale.token"
          />

          {/* Card 4 - Subscribe */}
          <Card
            buyMilesIcon={subscribeIcon} // Corrected: Added buyMilesIcon
            title="buy.button.new"
            description="buy.tooltip.subscribe"
            buttonText="buy.button.new"
            url="buy.subscribe.link.url"
            languageCode={languageCode}
            buttonClassName="gift-link-pcta-copy"
            buttonId="subscribe-cta-button"
            promoToken="subscribe.onsale.token"
          />
         
        </div>

        <p><Text languageCode={languageCode} token="buy.disclaimer1" /></p>
        <p><Text languageCode={languageCode} token="buy.disclaimer2" /></p>
        <p></p>
      </div>
    </div>
  );
}
